import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ShippingCost } from "../../../interfaces/shippingCostType";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { shippingCostApi } from "../services/shippingCost.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  SHIPPING_COST_MESSAGES_ERROR,
  SHIPPING_COST_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useSaveShippingCostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<ShippingCost>, Error, ShippingCost>({
    mutationFn: (shippingCost) => shippingCostApi.saveShippingCost(shippingCost),
    onSuccess: (res, variables) => {
      if (!res.ok) {
        errorNotification(SHIPPING_COST_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(SHIPPING_COST_MESSAGES_SUCCESS.SAVE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["shipping-costs-filter"] });
      queryClient.invalidateQueries({ queryKey: ["shipping-costs"] });
      if (variables._id) {
        queryClient.invalidateQueries({
          queryKey: ["shipping-cost-by-id", variables._id],
        });
      }
    },
    onError: () => {
      errorNotification(SHIPPING_COST_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
